import { Typography } from '@mui/material';
import type { MouseEvent } from 'react';
import { type ReactNode, useState } from 'react';
import { DeleteButton, type StandardButtonProps } from '../../buttons';
import { CancelConfirmDialog } from '../CancelConfirmDialog/CancelConfirmDialog';

export interface DeleteDialogProps
  extends Omit<StandardButtonProps, 'startIcon' | 'endIcon'> {
  onConfirm?: (e: MouseEvent<HTMLButtonElement>) => void | Promise<void>;
  texts?: {
    deleteButton?: string;
    cancel?: string;
    title?: string;
    confirmBody?: ReactNode | string;
    confirmButton?: string;
  };
}

export default ({
  onClick,
  texts,
  onConfirm,
  loading,
  ...rest
}: DeleteDialogProps) => {
  const [showModal, setShowModal] = useState(false);

  const {
    deleteButton = 'Delete',
    cancel = 'Cancel',
    title = 'Delete',
    confirmBody = 'Do you want to continue? This action cannot be undone.',
    confirmButton = 'Delete',
  } = texts || {};

  const handleOpen = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleConfirm = async (e: MouseEvent<HTMLButtonElement>) => {
    await onConfirm?.(e);
    handleClose();
  };

  return (
    <CancelConfirmDialog
      button={
        <DeleteButton onClick={handleOpen} text={deleteButton} {...rest} />
      }
      open={showModal}
      onClose={handleClose}
      title={title}
      onClickCancel={handleClose}
      onClickConfirm={handleConfirm}
      confirmText={confirmButton}
      cancelText={cancel}
      onLoadingConfirm={loading || false}
      confirmVariant="delete"
    >
      <Typography variant="body2">{confirmBody}</Typography>
    </CancelConfirmDialog>
  );
};
